// extracted by mini-css-extract-plugin
export default {"container":"ChangePasswordModal_container__6ganh"};